// 配置验证工具
import { AppConfig } from './index';

export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export const validateConfig = (config: AppConfig): ValidationResult => {
  const errors: string[] = [];

  // 验证API配置
  if (!config.api.baseURL) {
    errors.push('API baseURL is required');
  } else if (!isValidUrl(config.api.baseURL)) {
    errors.push('API baseURL must be a valid URL');
  }

  if (!config.api.version) {
    errors.push('API version is required');
  }

  if (!config.api.path) {
    errors.push('API path is required');
  }

  if (config.api.timeout <= 0) {
    errors.push('API timeout must be greater than 0');
  }

  if (!config.env) {
    errors.push('Environment is required');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const logConfigValidation = (config: AppConfig): void => {
  const validation = validateConfig(config);
  
  if (!validation.isValid) {
    console.error('Configuration validation failed:', validation.errors);
  } else {
    console.log('Configuration validation passed');
    console.log('Current config:', config);
  }
}; 